import { formatNumber } from "@angular/common";
import { Injectable, LOCALE_ID } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class UiHelperService {
  constructor() {}

  public getPumpState(threshold?: number, currentValue?: number): string {
    if (threshold && currentValue) {
      var result;
      if (threshold < currentValue) {
        result = true;
      } else {
        result = false;
      }
      return this.getSwitchString(result);
    }
    return "-";
  }

  public getTemperatureString(value?: number): string {
    return this.getNumberString(value, "°C");
  }

  public getPressureString(value?: number): string {
    return this.getNumberString(value, "bar");
  }

  public getRawString(value?: number): string {
    return this.getNumberString(value, "");
  }

  private getNumberString(value: number | undefined, unit: string): string {
    if (value != undefined) {
      const result = formatNumber(value, "DE-de", "1.1-4");
      return `${result} ${unit}`;
    }
    return "-";
  }

  public getSwitchString(value?: boolean): string {
    if (value != undefined) {
      return this.getBooleanString(value, "AN", "AUS");
    }
    return "-";
  }

  public getTriggerString(value?: boolean): string {
    if (value != undefined) {
      return this.getBooleanString(value, "AUSGELÖST", "NICHT AUSGELÖST");
    }
    return "-";
  }

  private getBooleanString(
    value: boolean | undefined,
    trueStr: string,
    falseStr: string
  ): string {
    if (value != undefined) {
      if (value) {
        return trueStr;
      } else {
        return falseStr;
      }
    }
    return "-";
  }

  public getPumpeValueFromHtml(element: HTMLInputElement): number | undefined {
    var newValue = element.value;
    if (newValue) {
      if (newValue == "10A") {
        return 10;
      } else if (newValue == "20A") {
        return 20;
      }
    }
    return undefined;
  }
}
